import { useLocation } from "react-router";

import { urlFor } from "~/lib/sanity/urlFor";

export default function SeoHead({
  seo: {
    title,
    canonicalURL,
    description = "Heavybit is the leading investor in developer-first companies with an unrivaled track record helping technical founders achieve breakout success",
    OGimage,
    noindex,
    nofollow,
    OGtitle,
    OGdescription,
  },
}: {
  seo: any;
}) {
  const location = useLocation();
  const getMetaImage = () => {
    try {
      const metaImage = OGimage
        ? typeof OGimage === "string"
          ? OGimage
          : urlFor(OGimage).toString()
        : undefined;

      return metaImage;
    } catch (error) {
      return undefined;
    }
  };

  const page = new URLSearchParams(location.search).get("page");

  const canonicalUrl =
    canonicalURL ||
    `https://www.heavybit.com${location.pathname.replace(/\/$/, "")}${page ? `?page=${page}` : ""}`;

  const finalTitle = `${title ? title + " | Heavybit" : "Heavybit"}`;

  const image = getMetaImage();

  return (
    <>
      <title>{finalTitle}</title>
      <meta property="og:title" name="og:title" content={OGtitle ?? finalTitle} />
      <meta property="twitter:title" name="twitter:title" content={OGtitle ?? finalTitle} />

      {canonicalUrl ? (
        <>
          <link rel="canonical" href={canonicalUrl} />
          <meta property="og:url" name="og:url" content={canonicalUrl} />
        </>
      ) : null}

      {!noindex && !nofollow ? null : (
        <meta
          property="robots"
          name="robots"
          content={`${noindex ? "noindex" : ""}${
            !nofollow ? "" : noindex ? ", nofollow" : "nofollow"
          }`}
        />
      )}

      {description ? (
        <>
          <meta property="description" name="description" content={description} />
          <meta property="og:description" content={OGdescription ?? description} />
        </>
      ) : null}

      {image ? (
        <>
          <meta property="og:image" name="og:image" content={image} />
          <meta property="twitter:card" name="twitter:card" content="summary_large_image" />
        </>
      ) : null}

      <meta content="Heavybit" property="og:site_name" />
      <meta content="@heavybit" name="twitter:site" />
      <meta content="@heavybit" name="twitter:creator" />

      <link
        rel="sitemap"
        type="application/xml"
        title="Sitemap"
        href="https://www.heavybit.com/sitemap.xml"
      />
    </>
  );
}
